<template>
  <div>
    <div id="barcode-management">
      <v-row no-gutters>
        <v-col cols="12">
          <!-- <snt-breadcrumb :match="(matched) => $t(`breadcrumb.${$_.camelCase(matched.name)}`)" /> -->
        </v-col>
        <v-col
          cols="12"
          sm="8">
          <div class="d-flex align-center gap-2 mb-6">
            <v-icon color="primary">
              mdi-barcode
            </v-icon>
            <div class="title primary--text font-weight-medium">
              จัดการบาร์โค้ด
            </div>
          </div>
        </v-col>
        <v-col cols="12">
          <v-tabs
            v-model="tab"
            height="56"
            background-color="transparent"
            show-arrows>
            <v-tab
              v-for="tabItem in tabItems"
              :key="tabItem.value"
              :to="tabItem.to"
              :ripple="false">
              {{ tabItem.value }}
            </v-tab>
            <v-tabs-slider color="primary"></v-tabs-slider>
          </v-tabs>
          <v-card
            class="tab-router-view pa-10"
            elevation="0"
            tile>
            <router-view />
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      apiUrl: process.env.VUE_APP_API,
      tab: 'สร้างบาร์โค้ด',
      tabItems: [
        {
          value: 'สร้างบาร์โค้ด',
          to: { name: 'ProductBarcodeCreateBarcode' }
        },
        {
          value: 'พิมพ์บาร์โค้ด',
          to: { name: 'ProductBarcodePrintBarcode' }
        }
      ]
    }
  }
}
</script>

<style lang="scss">
#barcode-management {
  .v-tab.v-tab--active {
    background-color: #ffffff;
  }
  .v-tab {
    padding: 0 30px;
    margin: 0 4px;
    background-color: #ECECEC;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    min-width: 196px;
    font-size: 1rem;
    font-weight: 400;
  }
  .v-tab--active {
    font-weight: 600;
  }
  .v-tab:nth-child(2) {
    margin-left: 0 !important;
  }
  .v-tabs-slider-wrapper {
    padding: 0 15px;
  }
}
</style>
